import asimov from '@99designs/asimov/core';
import $ from 'jquery';
import Uploader from 'launch/lib/legacy-uploader-lib';

var pluginName = 'uploader';
var defaults = {
    name: 'default',
    listselector: '.js-uploader-list',
    buttonselector: '.js-uploader-button',
    button: null,
    hash: '',
    endpoint: '',
    params: {},
    inputname: 'file',
    totalfilesizename: '',
    sizelimit: 15 * 1024 * 1024, // 15 MB
    allowedextensions: [],
    hidefileinfo: false,
    extraDropzones: [document.body],
    template: '<li class="uploader__item">' +
    '<a href="#" class="uploader__box">' +
    '<div class="uploader__thumb"></div>' +
    '<div class="uploader__filename">' +
    '<span class="uploader__filename__icon"></span><span class="uploader__filename__text"></span>' +
    '</div>' +
    '<div class="uploader__progressinfo">' +
    '<div class="uploader__size"><span class="uploader__size__text"></span></div>' +
    '<div class="progress-bar"><div class="progress-bar__indicator"></div></div>' +
    '</div>' +
    '<span class="uploader__spinner"><span class="spinner">' +
    '</a>' +
    '</span><span class="uploader__item__finished"></span>' +
    '<a class="uploader__item__cancel" href="#">Cancel</a><a class="uploader__item__retry" href="#">Retry</a><a class="uploader__item__delete" href="#">Delete</a>' +
    '<a class="uploader__action-delete js-delete-file" href="#"></a>' +
    '<div class="uploader__status-text"></div>' +
    '<div class="uploader__fileinfo"><div class="uploader__fileext"></div><div class="uploader__filesize"></div></div>' +
    '</li>',
    classes: {
        progressBar: 'progress-bar__indicator',
        file: 'uploader__filename__text',
        size: 'uploader__size__text',
        success: 'uploader__item--success',
        fail: 'uploader__item--fail',
        uploading: 'uploader__item--uploading',
        waiting: 'uploader__item--waiting',
        spinner: 'uploader__spinner',
        statusText: 'uploader__status-text',
        finished: 'uploader__item__finished',
        retry: 'uploader__item__retry',
        deleteButton: 'uploader__item__delete',
        cancel: 'uploader__item__cancel'
    }
};

function build(options, elem) {
    var obj = new Uploader().init(options, elem);

    // Public API

    return {
        getName: function() {
            return options.name;
        },
        updateLink: function() {
            return obj.updateLink();
        }
    };
}

// Plugin definition

$.fn[pluginName] = function(options) {
    return this.each(function() {
        if (!$.data(this, pluginName)) {
            var opts = asimov.mergeElementData(
                $(this),
                pluginName,
                $.extend(true, {}, defaults, options)
            );

            $.data(this, pluginName, build(opts, this));
        }
    });
};



// WEBPACK FOOTER //
// ./src/web/js/launch/lib/legacy-uploader.js